module.exports = __webpack_public_path__ + "static/img/3.26b9aa3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/7/1/sp/3.png
// module id = wbNN
// module chunks = 0